import { agendaCaseAdapter } from './reducer'
import { EntityState } from '@reduxjs/toolkit'
import { RootState } from 'shared/store/store'
import { IMeetingAgendaModel } from '../../../models/BoardMeeting'

export interface ICaseError {
  id: string
  message: string
}

export interface ICaseReferances {
  [x: string]: HTMLDivElement
}

export interface IBaseState {
  loading: boolean
  error: string | null
  casesError: ICaseError[]
  focusedCaseId: string | null
}

interface IState extends EntityState<IMeetingAgendaModel, string>, IBaseState {}

interface AgendaSliceState {
  boardmeetings: { manage: { agenda: IState } }
}

const agendaSlice = (state: RootState) =>
  (state as unknown as AgendaSliceState).boardmeetings.manage.agenda

export const getMeetingAgendaCaseById =
  (caseId: string) => (state: RootState) =>
    agendaCaseAdapter.getSelectors(agendaSlice).selectById(state, caseId)

export const getAllAgendaCases = (state: RootState) =>
  agendaCaseAdapter.getSelectors(agendaSlice).selectAll(state)

export const getCaseError = (caseId: string) => (state: RootState) =>
  agendaSlice(state).casesError.find(({ id }) => id === caseId)

export const getCaseReferance = (state: RootState) =>
  agendaSlice(state).focusedCaseId
